import { AccountShell, ConsumerRegistrationPage, UnifiedLoginPage } from "./features/account";
import { resolveAccountRoute } from "./app/accountRoute";
import { ConsumerAccountPage } from "./features/consumer-account";
import { OrganizationAccessPage } from "./features/organization-access";
import { OrganizationWorkspacePage } from "./features/organization-workspace";

export function AccountPages() {
  const route = resolveAccountRoute(window.location.pathname);
  if (route.page === "login") return <UnifiedLoginPage />;
  if (route.page === "consumer-registration") return <ConsumerRegistrationPage />;
  if (route.page === "organization-access") {
    return <OrganizationAccessPage registration={route.registration} />;
  }
  if (route.page === "consumer-account") return <ConsumerAccountPage />;
  if (route.page === "organization-workspace") {
    return <OrganizationWorkspacePage slug={route.slug} />;
  }
  return (
    <AccountShell>
      <main className="account-main">
        <div className="account-empty">
          <h1>Sivua ei löytynyt</h1>
          <a href="/">Palaa etusivulle</a>
        </div>
      </main>
    </AccountShell>
  );
}
